import config from '../config';
import { request } from '../utils/request';

// const cloudPigeonDomain = `${config.host}${config.apiRouter.cloudPigeon}`;
// const dataPublishSystemDomain = `${config.host}${config.apiRouter.dataPublishSystem}`;
const devtoolDomain = `${config.host}${config.apiRouter.devtool}`;

const api = {
  templateList (data) {
    return request({
      method: 'POST',
      url: `/govcloud-node/node/datasource/searchData`,
      data: {
        'search': {
          'data_src_key': 'template_list',
        },
        't': Date.now(),
        'page_size': 15,
        'cur_page': 1,
      },
    });
  },
  getTemplateZipId (data) {
    return request({
      method: 'POST',
      url: `${devtoolDomain}/template/getTemplateZipId`,
      data: data,
    });
  },
  downloadTemplateZip (params) {
    return request({
      url: `${devtoolDomain}/template/getTemplateZipId`,
      params,
    });
  },
};
export default api;
